export type ClientRole = 'READ_ONLY' | 'CONSUMPTION_EDITOR' | 'INVOICE_EDITOR' | 'POWER_USER';
export type ClientAction = 'read' | 'consumption_write' | 'invoice_write' | 'full_write';

const allowedActions: Record<ClientRole, readonly ClientAction[]> = {
  READ_ONLY: ['read'],
  CONSUMPTION_EDITOR: ['read', 'consumption_write'],
  INVOICE_EDITOR: ['read', 'consumption_write', 'invoice_write'],
  POWER_USER: ['read', 'consumption_write', 'invoice_write', 'full_write'],
};

export function canPerformClientAction(
  role: ClientRole | null | undefined,
  action: ClientAction,
  primaryUser = false,
) {
  if (primaryUser) return true;
  return role ? allowedActions[role].includes(action) : false;
}
